import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { BsFillPrinterFill, BsFullscreen, BsFullscreenExit } from 'react-icons/bs';
import EpimedLogoImage from '../../assets/images/sponsors/logo_epimed.svg';
import LogicLogoImage from '../../assets/images/sponsors/logo_logic.svg';
import EpButton from '../EpButton';
import EpFormSelect from '../EpFormSelect';
import { printScreen, toggleFullscreen } from '../../utils/interactions';
import useTranslation from '../../hooks/useTranslation';

import './styles.scss';

const EpGlobalNavigation = ({
  handleChangeLanguage, languageOptions, languageDefaultOption, languageSelectRef,
}) => {
  const currentUserLanguage = localStorage.getItem('bi.userLanguage');

  // Tags do Globalization
  const InternationalBenchmarking = currentUserLanguage === 'pt-BR'
    ? 'Benchmarking <span class="project__title--highlight">Internacional</span>'
    : 'International <span class="project__title--highlight">Benchmarking</span>';
  const EndorsedBy = useTranslation('Endorsed by');
  const PoweredBy = useTranslation('Powered by');
  const Select = useTranslation('Select');

  const [fullscreenStatus, setFullscreenStatus] = useState(false);
  const [mQuery, setMQuery] = useState({
    matches: window.innerWidth > 1045,
  });

  // Atuliza o estado MQuery quando ele chega no tamanho 1045px
  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 1045px)');

    mediaQuery.addListener(setMQuery);
    return () => mediaQuery.removeListener(setMQuery);
  }, []);

  // Insere traduções com html nos lugares corretos
  useEffect(() => {
    document.getElementById('global-navigation__title').innerHTML = InternationalBenchmarking;
  }, [currentUserLanguage]);

  return (
    <>
      <nav className="global-navigation">
        <div className="global-navigation--left">
          <h1 id="global-navigation__title" className="project__title"> </h1>

          {(mQuery && mQuery.matches) && (
            <div className="global-navigation__sponsors">
              <ul className="sponsors__list">
                <li className="sponsors__list-item">
                  <span className="sponsors__list-item-description">{EndorsedBy}</span>
                  <a data-testid="sponsors__list-item-logo--LOGIC" href="https://www.icubenchmarking.com/" rel="noopener noreferrer" target="_blank">
                    <img className="sponsors__list-item-logo" alt="" src={LogicLogoImage} />
                  </a>
                </li>

                <li className="sponsors__list-item">
                  <span className="sponsors__list-item-description">{PoweredBy}</span>
                  <a data-testid="sponsors__list-item-logo--Epimed-Solutions" href="https://www.epimedsolutions.com/" rel="noopener noreferrer" target="_blank">
                    <img className="sponsors__list-item-logo" alt="" src={EpimedLogoImage} />
                  </a>
                </li>
              </ul>
            </div>
          )}
        </div>

        {(mQuery && mQuery.matches) && (
          <div className="global-navigation--right">
            <div className="global-navigation__actions">
              <EpButton
                actionType="button"
                buttonType="link-secondary"
                buttonStartIcon={<BsFillPrinterFill />}
                customClass="btn__footer"
                onClickFunc={printScreen}
                buttonSize="md"
              />

              <EpButton
                actionType="button"
                buttonType="link-secondary"
                buttonStartIcon={fullscreenStatus ? <BsFullscreenExit /> : <BsFullscreen />}
                customClass="btn__footer"
                onClickFunc={() => {
                  toggleFullscreen(); setFullscreenStatus(!fullscreenStatus);
                }}
                buttonSize="md"
              />

              <EpFormSelect
                selectOptions={languageOptions}
                inputId="select--language"
                customRef={languageSelectRef}
                placeholderText={Select}
                inputName="language"
                selectDefaultValue={languageDefaultOption}
                customClass="global-navigation__language-select"
                onChangeFunc={values => handleChangeLanguage(values)}
              />
            </div>
          </div>
        )}
      </nav>

    </>
  );
};

export default EpGlobalNavigation;

EpGlobalNavigation.defaultProps = {
  languageDefaultOption: null,
  languageOptions: null,
  languageSelectRef: null,
};

EpGlobalNavigation.propTypes = {
  handleChangeLanguage: PropTypes.func.isRequired,
  languageOptions: PropTypes.arrayOf(PropTypes.object),
  languageDefaultOption: PropTypes.objectOf(PropTypes.string),
  languageSelectRef: PropTypes.objectOf(PropTypes.any),
};
